import React from 'react';
import { AdaStoreContext } from './index';
import hoistNonReactStatics from 'hoist-non-react-statics';

// const withStores =  Component => {
//   return (
//     <div>
//       <AdaStoreContext.Consumer>
//         {
//           stores => {
//             const selectedStores = Object.keys(stores).reduce((acc, storeName)=> {
//               if (storeNames.indexOf(storeName)) {
//                 acc[storeName] = stores[storeName];
//               }
//               return acc;
//             }, {});
//             return (
//               <Component {...selectedStores} />
//             );
//           }
//         }
//       </AdaStoreContext.Consumer>
//     </div>
//   );
// }

const grabStores = (stores, storeNames) => {
  return Object.keys(stores).reduce((acc, storeName) => {
    if (storeNames.indexOf(storeName) > -1) {
      acc[storeName] = stores[storeName];
    }
    return acc;
  }, {});
};

const withStores = (...storeNames) => Component => {
  class WithStoreComponent extends React.Component {
    render() {
      return (
        <AdaStoreContext.Consumer>
          {stores => {
            const selectedStores = grabStores(stores, storeNames);
            return <Component {...this.props} {...selectedStores} />;
          }}
        </AdaStoreContext.Consumer>
      );
    }
  }

  WithStoreComponent.displayName = `withStores(${Component.displayName ||
    Component.name})`;
  return hoistNonReactStatics(WithStoreComponent, Component);
};

export default withStores;
